export function getVideoAssets() {
  return Promise.resolve(require("./videos.json"));
}

export function renderHero(containerId, videoAssets) {
  var heroVideoAssets = videoAssets.filter(function (v) {
    return v.hero;
  });

  var containerElement = document.getElementById(containerId);

  if (!containerElement) {
    console.error(`Element with ID "${containerId}" not found.`);
    return;
  }

  containerElement.className = "carousel slide";
  containerElement.dataset.bsRide = "carousel";

  var carouselIndicators = document.createElement("div");
  carouselIndicators.className = "carousel-indicators";

  var carouselItems = document.createElement("div");
  carouselItems.className = "carousel-inner";

  for (let i = 0; i < heroVideoAssets.length; i++) {
    var videoAsset = heroVideoAssets[i];
    var btn = document.createElement("button");
    btn.type = "button";
    btn.dataset.bsTarget = "#" + containerId;
    btn.dataset.bsSlideTo = i.toString();
    if (i === 0) {
      btn.className = "active";
      btn.setAttribute("aria-current", "true");
    }
    btn.setAttribute("aria-label", `Slide ${i + 1}`);
    carouselIndicators.appendChild(btn);

    var carouselItem = document.createElement("div");
    var active = i === 0 ? " active" : "";
    carouselItem.className = "carousel-item" + active;
    var img = document.createElement("img");
    img.className = "d-block w-100";
    img.src =
      "https://d1okaosfjqp6sh.cloudfront.net/image/upload/c_crop,g_faces,h_603,w_1600/" +
      videoAsset.poster;
    carouselItem.appendChild(img);
    var text = document.createElement("div");
    text.className =
      "carousel-caption bg-dark overlay rounded text-light d-none d-md-block";
    var html = "";
    html += "<h5>" + videoAsset.title + "</h5>";
    html += "<p>" + videoAsset.subtitle + "</p>";
    text.innerHTML = html;
    carouselItem.appendChild(text);
    carouselItem.dataset.assetId = videoAsset.id;
    carouselItem.addEventListener("click", (ev) => {
      const target = ev.target as HTMLElement;
      const parent = target.parentElement;

      if (parent && parent.dataset.assetId) {
        location.href =
          "https://plus.streamingtech.se/#/asset/" + parent.dataset.assetId;
      } else {
        console.warn("Could not find assetId from clicked element.");
      }
      return false;
    });
    carouselItems.appendChild(carouselItem);
  }
  containerElement.appendChild(carouselIndicators);
  containerElement.appendChild(carouselItems);

  var carouselControlPrev = document.createElement("button");
  carouselControlPrev.className = "carousel-control-prev";
  carouselControlPrev.type = "button";
  carouselControlPrev.dataset.bsTarget = "#stswe-video-carousel";
  carouselControlPrev.dataset.bsSlide = "prev";
  carouselControlPrev.innerHTML =
    '<span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="visually-hidden">Previous</span>';
  containerElement.appendChild(carouselControlPrev);

  var carouselControlNext = document.createElement("button");
  carouselControlNext.className = "carousel-control-next";
  carouselControlNext.type = "button";
  carouselControlNext.dataset.bsTarget = "#stswe-video-carousel";
  carouselControlNext.dataset.bsSlide = "next";
  carouselControlNext.innerHTML =
    '<span class="carousel-control-next-icon" aria-hidden="true"></span><span class="visually-hidden">Next</span>';
  containerElement.appendChild(carouselControlNext);
}

export function renderVideoAssets(containerId, videoAssets) {
  var containerElement = document.getElementById(containerId);
  var fluidContainer = document.createElement("div");
  fluidContainer.className = "container-fluid";
  var rowContainer = document.createElement("div");
  rowContainer.className = "row";
  fluidContainer.appendChild(rowContainer);

  for (var i = 0; i < videoAssets.length; i++) {
    var videoAsset = videoAssets[i];
    var cell = document.createElement("div");
    cell.className = "col-md-4 video-navbox text-light";
    cell.dataset.assetId = videoAsset.id;
    var posterUrl =
      "https://d1okaosfjqp6sh.cloudfront.net/image/upload/c_crop,g_faces,h_600,w_600/" +
      videoAsset.poster;
    cell.setAttribute(
      "style",
      "background: url('" + posterUrl + "') no-repeat; background-size: cover;"
    );
    var html = "";
    html += "<h5>" + videoAsset.subtitle + "</h5>";
    cell.innerHTML = html;
    /*
    cell.addEventListener('click', function(ev) {
      location.href = 'player.html?id=' + ev.target.dataset.assetId;
      return false;
    });
    */
    rowContainer.appendChild(cell);
  }
  containerElement?.appendChild(fluidContainer);
}

export function renderHeader(active) {
  var items = [
    { title: "Home", link: "index.html" },
    //    { "title": "Tickets", "link": "https://www.eventbrite.se/e/streaming-tech-sweden-2022-tickets-332888677997" },
    // { "title": "Streaming Tech TV+", "link": "https://plus.streamingtech.se/?utm_source=stswe" },
    { title: "STSWE26", link: "index.html" },
    { title: "STSWE25", link: "stswe25.html" },
    { title: "STSWE24", link: "stswe24.html" },
    { title: "STSWE23", link: "stswe23.html" },
    { title: "STSWE22", link: "stswe22.html" },
    { title: "STSWE19", link: "stswe19.html" },
    { title: "STSWE18", link: "stswe18.html" },
    { title: "STSWE17", link: "stswe17.html" },
  ];

  var headerElement = document.getElementById("header");
  renderNavbar(active, headerElement, items);
}

export function renderNavbar(active, container, items) {
  var navbar = document.createElement("nav");
  navbar.className = "navbar navbar-expand-lg navbar-dark";

  var navbarBrand = document.createElement("a");
  navbarBrand.className = "navbar-brand";
  navbarBrand.href = "index.html";
  var logo = document.createElement("img");
  logo.className = "logo";
  logo.src =
    "https://d1okaosfjqp6sh.cloudfront.net/image/upload/c_scale,h_50/STSWE-logo.png";
  logo.alt = "Streaming Tech Sweden";
  navbarBrand.appendChild(logo);

  navbar.appendChild(navbarBrand);

  // navbarContent must be declared before navbarToggler so the click listener
  // can reference it in its closure.
  var navbarContent = document.createElement("div");
  navbarContent.id = "navbarSupportedContent";
  navbarContent.className = "collapse navbar-collapse";

  var navbarToggler = document.createElement("button");
  navbarToggler.className = "navbar-toggler";
  navbarToggler.type = "button";
  navbarToggler.setAttribute("aria-controls", "navbarSupportedContent");
  navbarToggler.setAttribute("aria-expanded", "false");
  navbarToggler.setAttribute("aria-label", "Toggle navigation");
  navbarToggler.innerHTML = '<span class="navbar-toggler-icon"></span>';

  // The menu is toggled here in plain JS rather than through Bootstrap's
  // data-API. Do NOT also put data-bs-toggle="collapse" on this button: the
  // two fight each other. Bootstrap's delegated handler is registered on
  // document in the capture phase, so it runs first and sets the class, and
  // this listener then toggles it straight back — the menu opens once and can
  // never be closed again. Pick one owner; this is it.
  navbarToggler.addEventListener("click", function () {
    navbarContent.classList.toggle("show");
    navbarToggler.setAttribute(
      "aria-expanded",
      navbarContent.classList.contains("show") ? "true" : "false"
    );
  });

  navbar.appendChild(navbarToggler);
  navbar.appendChild(navbarContent);

  var navbarNav = document.createElement("ul");
  navbarNav.className = "navbar-nav ms-auto";
  navbarContent.appendChild(navbarNav);

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var li = document.createElement("li");
    if (item.title === active) {
      li.className = "nav-item active";
    } else {
      li.className = "nav-item";
    }
    li.innerHTML =
      '<a class="nav-link" href="' + item.link + '">' + item.title + "</a>";
    // Collapse the menu when the user taps a nav link on mobile
    li.addEventListener("click", function () {
      if (window.innerWidth < 992) {
        navbarContent.classList.remove("show");
        navbarToggler.setAttribute("aria-expanded", "false");
      }
    });
    navbarNav.appendChild(li);
  }

  container.appendChild(navbar);
}

/*
export function renderVideoPlayer(videoId, containerId, videoAssets) {
  var videoAsset = videoAssets.find(function(v) { return v.id === videoId });
  url = videoAsset.url;
  console.log(videoAsset);
  var videoContainer = document.getElementById(containerId);
  var dimmerContainer = document.getElementById('stswe-dimmer');
  window.addEventListener('resize', function(ev) {
    var h = (1080 / 1920) * window.innerWidth;
    videoContainer.setAttribute("style", "height: " + h + "px; width: " + window.innerWidth + "px");
    dimmerContainer.setAttribute("style", "height: " + document.body.clientHeight + "px");
  });
  var h = (1080 / 1920) * window.innerWidth;
  videoContainer.setAttribute("style", "height: " + h + "px; width: " + window.innerWidth + "px");
  dimmerContainer.setAttribute("style", "height: " + document.body.clientHeight + "px");
  if (url) {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isSafari && iOS) {
      location.href = url;
    } else {
      setupEyevinnPlayer(containerId, url).then(function(player) {
        player.play(false);
      });
    }
  }
}

function parseQueryParams(search) {
  var re = /[?&]([^=&]+)(=?)([^&]*)/g;
  var params = {};
  while (m = re.exec(search)) {
    params[decodeURIComponent(m[1])] = (m[2] == '=' ? decodeURIComponent(m[3]) : true);
  }
  return params;
}
*/

export function renderCheckout(widgets, element) {
  widgets.createWidget({
    widgetType: "checkout",
    eventId: "1299249944559",
    modal: true,
    modalTriggerElementId: element,
    onOrderComplete: () => {
    },
  });
}
